module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Oyster Lane",
    url: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    holding: {
        "brand": "https://via.placeholder.com/300x200?text=Brand+image",
        "message": "Website coming soon"
    },

    base: {
        "contact_address": "",
        "contact_number": "0800 246 5890",
        "contact_email": "contact@oysterlane.info"
    },

    meta: {
        "defaultSocialImage": "/assets/images/hero/aerial-of-site-and-its-boundary-showing-previous-building-in-place.webp",
        "author": "",
        "description": "",
        "gtag": "G-KEYLM0WPVH",
        "gtm": "GTM-T4RZVLKC"
    },

    form: {
        "contact": {
            "catcher_id": "55b15f8d519f753efa5d07086e7eb56c",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "ec401c77fa72652a0943337485a9d961"
        },
        "feedback": {
            "catcher_id": "9275c52ef40014b79485e67a6063b230",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "8212e53e192bac26bc682004fb272706"
        }
    },

    consultation: {
        "feedback_active": true,
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "First theme",
                "url": "section-1",
                "feedback_url": '',
                "icon": "drainage_strategy",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "01-section"
            },
            {
                "name": "Second theme",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "heritage",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "02-section"
            },
            {
                "name": "Third theme",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "environment",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "03-section"
            },
            {
                "name": "Fourth theme",
                "url": "section-4",
                "feedback_url": 'page-4/',
                "icon": "leisure_and_recreation",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "04-section"
            },
            {
                "name": "Fifth theme",
                "url": "section-5",
                "feedback_url": 'page-5/',
                "icon": "highways_and_transport",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "05-section"
            },
            {
                "name": "Sixth theme",
                "url": "section-6",
                "feedback_url": 'page-6/',
                "icon": "uncategorised",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "06-section"
            }
        ]
    },

    downloads: [
        {
            "title": "Download 1",
            "url": "#"
        },
        {
            "title": "Download 2",
            "url": "#"
        },
        {
            "title": "Download 3",
            "url": "#"
        }
    ],

    faqs: [
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: '',

    // Marker.io Key - replace this default key
    marker_io: '618d2de7be76ee21e8452764',

    // Cookiefirst ID
    cookieFirst: 'oyster-lane.info-42cd98d2-b847-47d8-a3b8-c217005cbe8f'
};
